import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, normalizeClass as _normalizeClass, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-560a8556"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-info" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "order-goods" }
const _hoisted_4 = { class: "goods-left" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "goods-img" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "goods-title" }
const _hoisted_9 = { class: "goods-price" }
const _hoisted_10 = { class: "goods-price-item" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = { class: "goods-right" }
const _hoisted_17 = { class: "order-price" }
const _hoisted_18 = { class: "goods-status" }
const _hoisted_19 = { class: "edit" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-shijian" }, null, -1))
const _hoisted_21 = {
  key: 3,
  class: "edit-status"
}
const _hoisted_22 = { class: "viprecord" }
const _hoisted_23 = { class: "title" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "物流信息", -1))
const _hoisted_25 = { class: "record" }
const _hoisted_26 = { class: "top" }
const _hoisted_27 = { class: "left" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "one" }, "快递公司:", -1))
const _hoisted_29 = { class: "two" }
const _hoisted_30 = { class: "left" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "one" }, "快递单号:", -1))
const _hoisted_32 = { class: "two" }
const _hoisted_33 = { class: "boxs" }
const _hoisted_34 = { class: "infor-top" }
const _hoisted_35 = { class: "time" }
const _hoisted_36 = {
  key: 0,
  class: "circle"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cir" }, null, -1))
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = {
  key: 1,
  class: "circle1"
}
const _hoisted_40 = { class: "status-box" }
const _hoisted_41 = {
  key: 0,
  class: "blue"
}
const _hoisted_42 = {
  key: 1,
  class: "status"
}
const _hoisted_43 = {
  key: 2,
  class: "status"
}
const _hoisted_44 = { class: "infor-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CountDown = _resolveComponent("CountDown")!
  const _component_InvoiceDialog = _resolveComponent("InvoiceDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(" 订单时间:"),
        _createElementVNode("span", null, _toDisplayString(_ctx.order.create_time), 1),
        _createTextVNode(" 订单编号:"),
        _createElementVNode("span", null, _toDisplayString(_ctx.order.oid), 1),
        (_ctx.order.name && _ctx.vipinfo.type == 2)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" 用户:"),
              _createElementVNode("span", null, _toDisplayString(_ctx.order.name), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.son, (son, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "goods-item",
              onClick: ($event: any) => (_ctx.goGoods(son.gid))
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("img", {
                  src: _ctx.getimgUrl(son.photo)
                }, null, 8, _hoisted_7)
              ]),
              _createElementVNode("p", _hoisted_8, _toDisplayString(son.names), 1),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", _hoisted_10, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["icon iconfont", {
									'icon-a-Group14379': _ctx.order.order_type != 1,
									'icon-renminbi': _ctx.order.order_type == 1,
								}])
                  }, null, 2),
                  _createTextVNode(_toDisplayString(_ctx.showPrice(son.money, _ctx.order.order_type)), 1)
                ]),
                (son.sales == 1)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: "refund",
                      onClick: _withModifiers(($event: any) => (_ctx.gotoSale(_ctx.order.id, son.gid, _ctx.order.oid)), ["stop"])
                    }, [
                      (son.sales_status == 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, " 退款失败 "))
                        : (son.refund_status == 4)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, " 退款撤销 "))
                          : (son.refund_status < 3)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, " 退款中 "))
                            : (son.refund_status == 3)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15, " 退款成功 "))
                              : _createCommentVNode("", true)
                    ], 8, _hoisted_11))
                  : _createCommentVNode("", true)
              ])
            ], 8, _hoisted_5))
          }), 256))
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createTextVNode(" 实付款 "),
            _createElementVNode("span", null, [
              _createElementVNode("i", {
                class: _normalizeClass(["icon iconfont", {
								'icon-a-Group14379': _ctx.order.order_type != 1,
								'icon-renminbi': _ctx.order.order_type == 1,
							}])
              }, null, 2),
              _createTextVNode(_toDisplayString(_ctx.showPrice(_ctx.order.price, _ctx.order.order_type)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.getStatusText(
							_ctx.order.status,
							_ctx.order.forRrestOf,
							_ctx.order.order_type,
							_ctx.order.send_status
						)), 1),
          _createElementVNode("div", _hoisted_19, [
            (_ctx.order.status == 1 && _ctx.getTime(_ctx.order.forRrestOf) > 0)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "edit-pay-tips",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getTime(_ctx.order.forRrestOf)))
                }, [
                  _hoisted_20,
                  _createTextVNode("剩余时间: "),
                  _createVNode(_component_CountDown, {
                    totaltime: _ctx.getTime(_ctx.order.forRrestOf)
                  }, null, 8, ["totaltime"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.order.status == 1 && _ctx.getTime(_ctx.order.forRrestOf) > 0)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: "edit-pay",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toBePaid(_ctx.order.id)))
                }, "去付款"))
              : _createCommentVNode("", true),
            (
							(_ctx.order.status == 2 &&
								(_ctx.order.send_status == 1 || _ctx.order.send_status == 2) &&
								_ctx.showSend &&
								(_ctx.userinfot.pid == 0 || _ctx.userinfot.id == _ctx.order.uid) &&
								_ctx.order.order_type == 0) ||
							(_ctx.order.order_type == 1 && _ctx.order.send_status == 2 && _ctx.showSend)
						)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 2,
                  class: "confirm-receipt",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateConfirmReceipt(_ctx.order.id)))
                }, "确认收货"))
              : _createCommentVNode("", true),
            (
							_ctx.order.status == 2 &&
							(_ctx.order.send_status == 0 || _ctx.order.send_status == 3 || !_ctx.showSend)
						)
              ? (_openBlock(), _createElementBlock("span", _hoisted_21, "交易成功"))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.orderInfo(_ctx.order.id, _ctx.order.order_type)))
            }, "订单详情"),
            (
							(_ctx.order.status == 3 ||
								(_ctx.order.status == 1 && _ctx.getTime(_ctx.order.forRrestOf) <= 0)) &&
							(_ctx.userinfot.pid == 0 || _ctx.userinfot.id == _ctx.order.uid)
						)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 4,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateOrderStatus(_ctx.order.id, 4)))
                }, "删除订单"))
              : _createCommentVNode("", true),
            (
							_ctx.order.status == 1 &&
							_ctx.getTime(_ctx.order.forRrestOf) > 0 &&
							(_ctx.userinfot.pid == 0 || _ctx.userinfot.id == _ctx.order.uid)
						)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 5,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateOrderStatus(_ctx.order.id, 3)))
                }, "取消订单"))
              : _createCommentVNode("", true),
            (_ctx.order.status == 2 && _ctx.order.order_type == 0)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 6,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toDown(_ctx.order.id)))
                }, "下载"))
              : _createCommentVNode("", true),
            (_ctx.order.expressname != null && _ctx.order.expressnumber != null)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 7,
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.viewLogistics(_ctx.order.expressname, _ctx.order.expressnumber)))
                }, "查看物流"))
              : _createCommentVNode("", true),
            (_ctx.order.order_type == 1 && _ctx.order.status == 2)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 8,
                  class: "post-sale",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.postSale(_ctx.order.id)))
                }, "退换/售后"))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_InvoiceDialog, {
      ref: "sonRef",
      dialogwidth: "580px",
      class: "infor"
    }, {
      default: _withCtx(({}) => [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("i", {
              class: "iconfont closeicon",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.mclose()))
            }, "")
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.order.expressname), 1)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.order.expressnumber), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ExpressInfo.data.list, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "infor-box",
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, _toDisplayString(item.time), 1),
                    (index == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_38))
                      : _createCommentVNode("", true),
                    (index != 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_39))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_40, [
                      (index == 0 && _ctx.ExpressInfo.data.list.length > 1)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_41, _toDisplayString(_ctx.deliveryStatus), 1))
                        : (index == _ctx.ExpressInfo.data.list.length - 1)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_42, " 已揽件 "))
                          : (_openBlock(), _createElementBlock("p", _hoisted_43, "运输中"))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_44, _toDisplayString(item.status), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
}